import { CloseSharp } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useCallback, useLayoutEffect, useRef, useState } from "react";
import { FailurePop, SuccessPop } from "../../Components/Popup";
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import {
  LastNumber,
  LastURL,
  SignInStatus,
} from "../../Components/reducers/config";
import { useNavigate } from "react-router-dom";
import UserInfoPop from "./UserInfoPop";

const SigninPop = ({ openSignin, setOpenSignin }) => {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const theme = useTheme();
  const inputRef = React.createRef();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const getPastLocation = useSelector((url) => url.lastURL);

  //useStates
  const [mobileNumber, setMobileNumber] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalFail, setModalFail] = useState(false);
  const [content, setContent] = useState("");
  const [loader, setLoader] = useState(false);
  const [verify, setVerify] = useState(false);
  const [OTP, setOTP] = useState("");
  const [detailPop, setDetailPop] = useState(false);

  const [time, setTime] = useState(30);
  const [Disable, setDisable] = useState(false);

  const timerRef = useRef(time);

  const Timer = async () => {
    const timerId = setInterval(() => {
      timerRef.current -= 1;
      if (timerRef.current < 0) {
        clearInterval(timerId);
        // setTime(30);
        setDisable(false);
        timerRef.current += 31;
      } else {
        setTime(timerRef.current);
      }
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  };

  //Function

  function handleClose() {
    setOpenSignin(false);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      loginValidate();
    }
  };

  const handleMobile = async (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    if (onlyNums.length < 11) {
      setMobileNumber(onlyNums);
    }
  };

  function handleChange(OTP) {
    setOTP(OTP);
    if (OTP.length == 4) {
      // Navigate("/app");
      otpValidate(OTP);
    }
  }

  //API
  const loginValidate = async () => {
    setLoader(true);
    if (!mobileNumber) {
      setContent("Please Provide Mobile Number");
      setModalFail(true);
      setLoader(false);
      return true;
    }

    if (mobileNumber.length !== 10) {
      setContent("Mobile Number should be 10 Digit");
      setModalFail(true);
      setLoader(false);
      return true;
    }
    try {
      const response = await global.$axios.post("customer/loginOtpMail", {
        mobile: mobileNumber,
      });
      console.log("response", response.data);
      if (response.data.status == "success") {
        dispatch(LastNumber(mobileNumber));
        setTimeout(() => {
          setLoader(false);
          setVerify(true);
        }, 2000);
      } else {
        setContent(response.data.message);
        setModalFail(true);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log("Login Issue", error);
      setContent("Something Went Wrong, Try Again");
      setModalFail(true);
    }
  };

  const clearToken = async () => {
    try {
      const response = await global.$axios.get("customer/device_info");
      console.log("response", response.data);
    } catch (error) {
      console.log("Clear Token Issue", error);
    }
  };

  const resendotp = async () => {
    try {
      const response = await global.$axios.post("/customer/resendOtp", {
        mobile: mobileNumber,
      });

      console.log("response", response.data);
    } catch (error) {
      console.log("Resend OTP Issue", error);
    }
  };

  const otpValidate = async (OTP) => {
    try {
      const response = await global.$axios.post("customer/verifyOtp", {
        mobile: mobileNumber,
        otp: OTP,
        device_type: "web",
      });
      console.log("Otp response", response.data);
      if (response.data.status == "success") {
        dispatch({
          type: "SET_USER_IN",
          data: { ...response.data, ...{ reload: false } },
          payload: true,
        });
        dispatch(SignInStatus(true));

        await clearToken();

        if (response.data.user_type === "New") {
          setDetailPop(true);
        } else {
          handleClose();
          if (getPastLocation) {
            Navigate(getPastLocation);
          }
          dispatch(LastURL(null));
          window.location.reload();
        }
      } else {
        setContent(response.data.message);
        setModalFail(true);
        setTimeout(() => {
          setModalFail(false);
        }, 2000);
      }
    } catch (error) {
      setContent("Something Went Wrong, Try again..");
      setModalFail(true);
      setTimeout(() => {
        setModalFail(false);
      }, 2000);
      console.log("OTP Verification Issue", error);
    }
  };

  const focusInput = useCallback(() => {
    inputRef.current?.focus();
  }, [inputRef]);

  useLayoutEffect(() => {
    focusInput();
  }, [focusInput]);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        fullWidth={true}
        maxWidth={"sm"}
        open={openSignin}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
      >
        <Grid sx={{ py: 2, px: 1 }}>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pr: { sm: 2 },
            }}
          >
            <DialogTitle>
              <Typography sx={{ color: "#071CB7", fontWeight: 600 }}>
                {verify ? "Verify Account" : "Sign In / Sign Up to continue"}
              </Typography>
            </DialogTitle>
            <IconButton sx={{ p: 0 }} onClick={handleClose}>
              <CloseSharp sx={{ color: "red" }} />
            </IconButton>
          </Grid>

          <DialogContent sx={{ px: { sm: 3, xs: 0 } }}>
            <Grid container sx={{ px: 3 }}>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 6,
                  gap: 2,
                }}
              >
                <Typography>
                  {verify
                    ? `Please enter the OTP sent to ${mobileNumber}`
                    : "Enter Mobile Number"}
                </Typography>
                {verify ? (
                  <>
                    <OTPInput
                      value={OTP}
                      onChange={handleChange}
                      shouldAutoFocus
                      inputStyle={{
                        width: "35px",
                        height: "45px",
                        borderRadius: "7px",
                        border: "0.5px solid #C2C2C2",
                        background: "#FFF",
                        fontSize: "20px",
                      }}
                      containerStyle={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                      numInputs={4}
                      separator={<span></span>}
                      renderInput={(props) => <input {...props} />}
                    />
                    <Grid
                      container
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                      }}
                    >
                      <Button
                        variant="text"
                        sx={{ textTransform: "none" }}
                        onClick={() => setVerify(false)}
                      >
                        change number?
                      </Button>
                      <Grid
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          justifyContent: "flex-start",
                          px: 2,
                        }}
                      >
                        <Button
                          variant="text"
                          sx={{ textTransform: "none" }}
                          onClick={() => {
                            setDisable(true);
                            Timer();
                            resendotp();
                          }}
                          disabled={Disable}
                        >
                          Resend OTP
                        </Button>
                        {time > 0 && time < 30 ? (
                          <Typography sx={{ px: 2, color: "#C2C2C2" }}>
                            {time > 9 ? `00:${time}` : `00:0${time}`}
                          </Typography>
                        ) : (
                          <Typography sx={{ color: "transparent" }}>
                            5K
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <TextField
                    ref={inputRef}
                    value={mobileNumber}
                    autoFocus={true}
                    onChange={(e) => handleMobile(e)}
                    placeholder="Your Mobile Number Here..."
                    onKeyDown={handleKeyDown}
                    size="small"
                    fullWidth
                    sx={{
                      border: "1px solid #7896FF",
                      borderRadius: 1,
                      mt: 0.5,
                    }}
                  />
                )}

                {!verify && (
                  <Button
                    sx={{
                      background: "#071CB7",
                      px: 5,
                      textTransform: "capitalize",
                    }}
                    variant="contained"
                    size="medium"
                    disabled={!mobileNumber || loader}
                    onClick={loginValidate}
                  >
                    {loader ? "Sending OTP" : "Send OTP"}
                  </Button>
                )}
                <Grid sx={{ mt: 4 }}>
                  <Typography sx={{ fontSize: 12 }}>
                    By proceeding, you agree to 5k Car Care{"’"}s{" "}
                    <span
                    // style={{ color: "#071CB7", cursor: "pointer" }}
                    // onClick={() => {
                    //   localStorage.setItem("ProfileTab", "Terms");
                    //   Navigate("/app/profile");
                    // }}
                    >
                      T&C
                    </span>{" "}
                    and{" "}
                    <span
                    // style={{ color: "#071CB7", cursor: "pointer" }}
                    >
                      Privacy Policy
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Grid>
      </Dialog>
      {modalSuccess && (
        <SuccessPop
          modalSuccess={modalSuccess}
          setModalSuccess={setModalSuccess}
          content={content}
        />
      )}
      {modalFail && (
        <FailurePop
          modalFail={modalFail}
          setModalFail={setModalFail}
          content={content}
        />
      )}
      {detailPop && (
        <UserInfoPop
          detailPop={detailPop}
          setDetailPop={setDetailPop}
          setOpenSignin={setOpenSignin}
        />
      )}
    </div>
  );
};

export default SigninPop;
